import React, { Component } from 'react';
import classNames from 'classnames';
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import { monitor } from '../../store/actions';
import { REALTIME_NOTIFICATIONS_SOUND_ENABLED_CHANGE_IN_LS } from '../../../RealtimeNotifications/shared/constants';
import { NotificationSound } from '../../../NotificationSound';
import { setSoundEnabled } from './api';
import './style.scss';

export class ButtonToggleSounds extends Component {
    constructor(props) {
        super(props);

        this.state = {
            soundEnabled: props.notificationSoundEnabled,
        };

        this.handleToggle = this.handleToggle.bind(this);
    }

    componentDidMount() {
        window.addEventListener('storage', this.onStorageChanges);
        document.addEventListener(REALTIME_NOTIFICATIONS_SOUND_ENABLED_CHANGE_IN_LS, this.onCurrentTabStorageChange);
    }

    componentWillUnmount() {
        window.removeEventListener('storage', this.onStorageChanges);
        document.removeEventListener(REALTIME_NOTIFICATIONS_SOUND_ENABLED_CHANGE_IN_LS, this.onCurrentTabStorageChange);
    }

    onStorageChanges = ({ key, newValue }) => {
        if (key !== REALTIME_NOTIFICATIONS_SOUND_ENABLED_CHANGE_IN_LS) {
            return;
        }

        const { soundEnabled } = this.state;

        // We do so because this value is sent from localStorage as string.
        const normalizedValue = newValue === 'true';
        if (normalizedValue !== soundEnabled) {
            this.setState({ soundEnabled: normalizedValue });
        }
    };

    onCurrentTabStorageChange = ({ detail }) => {
        this.onStorageChanges(detail);
    };

    reportSoundSettingsChange = (newSoundSetting) => {
        // This storage update in order to communicate other opened tabs of this value.
        // other tabs will get a `storage` event informing them of the updated key/value.
        localStorage.setItem(REALTIME_NOTIFICATIONS_SOUND_ENABLED_CHANGE_IN_LS, newSoundSetting);

        // `storage` event is not called in same tab so we need to dispatch the data as a document event as well.
        let event;
        const eventData = {
            detail: {
                key: REALTIME_NOTIFICATIONS_SOUND_ENABLED_CHANGE_IN_LS,
                newValue: newSoundSetting.toString(),
            },
        };

        if (typeof window.CustomEvent === 'function') {
            event = new CustomEvent(REALTIME_NOTIFICATIONS_SOUND_ENABLED_CHANGE_IN_LS, eventData);
        } else {
            event = document.createEvent('CustomEvent');
            event.initCustomEvent(REALTIME_NOTIFICATIONS_SOUND_ENABLED_CHANGE_IN_LS, false, false, eventData.detail);
        }

        document.dispatchEvent(event);
    };

    handleToggle() {
        const { soundEnabled } = this.state;
        const newSoundSetting = !soundEnabled;

        // If toggled ON play sound.
        if (newSoundSetting) {
            NotificationSound.playSound();
        }

        setSoundEnabled(newSoundSetting);
        this.reportSoundSettingsChange(newSoundSetting);

        this.setState({
            soundEnabled: newSoundSetting,
        });

        this.props.monitor(null, 'toggle_sound', soundEnabled ? 'on' : 'off');
    }

    render() {
        const buttonClassName = classNames('btn-toggle-sound', {
            on: this.state.soundEnabled,
        });

        return (
            <button onClick={this.handleToggle} className={buttonClassName}>
                <i />
            </button>
        );
    }
}

ButtonToggleSounds.propTypes = {
    monitor: propTypes.func,
    notificationSoundEnabled: propTypes.bool,
};

export default connect(null, { monitor })(ButtonToggleSounds);
